var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGridFour = function SvgIconGridFour(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.125 19.125c0 .966.784 1.75 1.75 1.75h14.25a1.75 1.75 0 0 0 1.75-1.75V4.875a1.75 1.75 0 0 0-1.75-1.75H4.875a1.75 1.75 0 0 0-1.75 1.75zm2-6.125v5.875H11V13zm0-2H11V5.125H5.125zM13 13v5.875h5.875V13zm5.875-2H13V5.125h5.875z",
    clipRule: "evenodd"
  })));
};
export default SvgIconGridFour;